(() => {
  'use strict';
  if (window.ARMATEQBNPL) return;
  let currentCart;
  const disclosures = new WeakSet();
  const refreshKlarna = () => window.Klarna?.OnsiteMessaging?.refresh?.();
  const ensureProviders = root => {
    const clientId = root.dataset.nmKlarnaClientId;
    if (clientId && !window.Klarna && !document.querySelector('script[src="https://js.klarna.com/web-sdk/v1/klarna.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
      script.async = true;
      script.dataset.environment = 'production';
      script.dataset.clientId = clientId;
      script.addEventListener('load', refreshKlarna, { once: true });
      document.head.append(script);
    }
    if (!customElements.get('square-placement') && !document.querySelector('script[src="https://js.squarecdn.com/square-marketplace.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.squarecdn.com/square-marketplace.js';
      script.async = true;
      document.head.append(script);
    }
  };
  const renderRoot = (root, amount, value) => {
    const cents = Math.max(0, Math.round(Number(amount) || 0));
    const context = root.dataset.nmBnpl;
    let eligible = root.dataset.nmEligible !== 'false';
    if (context === 'cart' && value?.items) eligible = !value.items.some(item => item.gift_card);
    root.dataset.nmEligible = String(eligible);
    root.dataset.nmAmount = String(cents);
    if (!eligible || cents <= 0) {
      root.hidden = true;
      root.querySelectorAll('klarna-placement, square-placement').forEach(placement => placement.remove());
      delete root.dataset.nmMounted;
      return false;
    }
    const template = root.querySelector('[data-nm-bnpl-template]');
    if (!template) return false;
    const disclosure = root.querySelector('[data-nm-bnpl-disclosure]');
    if (disclosure && !disclosures.has(disclosure)) {
      disclosure.addEventListener('toggle', () => {
        if (disclosure.open && !root.hidden) refreshKlarna();
      });
      disclosures.add(disclosure);
    }
    const mounting = root.dataset.nmMounted !== 'true';
    const target = mounting ? template.content.cloneNode(true) : root;
    target.querySelector('klarna-placement')?.setAttribute('data-purchase-amount', String(cents));
    const afterpay = target.querySelector('square-placement');
    if (afterpay) {
      afterpay.setAttribute('data-amount', (cents / 100).toFixed(2));
      afterpay.setAttribute('data-is-eligible', 'true');
      afterpay.setAttribute('data-cart-is-eligible', 'true');
      if (context === 'cart' && value?.items) {
        afterpay.setAttribute('data-item-skus', value.items.map(item => item.sku || item.variant_id).join(','));
        afterpay.setAttribute('data-item-categories', [...new Set(value.items.map(item => item.product_type).filter(Boolean))].join(','));
      } else if (value?.id) afterpay.setAttribute('data-item-skus', value.sku || String(value.id));
    }
    root.hidden = false;
    if (mounting) {
      (root.querySelector('[data-nm-bnpl-messages]') || root).append(target);
      root.dataset.nmMounted = 'true';
    }
    ensureProviders(root);
    return true;
  };
  const update = (amount, context = 'product', value) => {
    if (context === 'cart' && value?.items) currentCart = value;
    let hasPlacements = false;
    document.querySelectorAll('[data-nm-bnpl]').forEach(root => {
      if (root.dataset.nmBnpl !== context) return;
      if (renderRoot(root, amount, value)) hasPlacements = true;
    });
    if (hasPlacements) refreshKlarna();
  };
  const initialize = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-nm-bnpl]')];
    if (scope.matches?.('[data-nm-bnpl]')) roots.unshift(scope);
    let hasPlacements = false;
    roots.forEach(root => {
      const value = root.dataset.nmBnpl === 'cart' ? currentCart : undefined;
      if (renderRoot(root, value?.total_price ?? root.dataset.nmAmount, value)) hasPlacements = true;
    });
    if (hasPlacements) refreshKlarna();
  };
  window.ARMATEQBNPL = { update };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
